import { store, environmentsAtom, Environment, secureAtom } from './store';

export function getEnvironments({
  keys = [],
}: {
  keys?: string[] | [];
}): Environment {
  const environments = store.get(environmentsAtom);
  let _enviroments: any = {};
  if (!environments) {
    return {};
  }
  if (typeof environments === 'string') {
    try {
      _enviroments = JSON.parse(environments);
    } catch {
      _enviroments = {};
    }
  } else if (typeof environments === 'object') {
    _enviroments = environments;
  }
  if (!_enviroments) return {};

  if (keys.length > 0) {
    const _keys = keys.map(key => {
      if (!_enviroments[key]) {
        return {};
      }
      return {
        [key]: _enviroments[key],
      };
    });
    return Object.assign({}, ..._keys);
  }

  return _enviroments;
}

export function updateEnvironments(newEnvironments: any): void {
  store.set(environmentsAtom, newEnvironments);
}

export function getSecure(): string {
  const secure = store.get(secureAtom);
  if (!secure) {
    return '';
  }

  return secure;
}
export function updateSecure(newSecure: string): void {
  store.set(secureAtom, newSecure);
}
